import { jsxs as a, jsx as o } from "react/jsx-runtime";
import { forwardRef as c } from "react";
import { Tooltip as f } from "./index27.js";
import "./index28.js";
import "./index29.js";
import "./index30.js";
import "./index31.js";
import "./index32.js";
import "./index33.js";
import "./index34.js";
import "./index35.js";
import h from "./index36.js";
import "./index37.js";
const x = c(
  ({
    label: r,
    tooltip: t,
    error: p,
    warning: i,
    success: m,
    maskOpts: l = {},
    //? How to use => https://imask.js.org/guide.html
    maskCallback: e,
    value: u,
    ...n
  }, d) => /* @__PURE__ */ a("div", { className: `textbox-ui input-ui ${r ? "" : "no-placeholder"}`, children: [
    /* @__PURE__ */ a(
      "label",
      {
        className: t ? "has-tooltip" : "",
        "data-error": p || null,
        "data-alert": i || null,
        "data-success": m || null,
        children: [
          r && /* @__PURE__ */ o("span", { children: r }),
          /* @__PURE__ */ o(
            h,
            {
              inputRef: d,
              placeholder: r,
              unmask: !0,
              ...l,
              onAccept: (s) => {
                !n.disabled && e && e(s);
              },
              value: u,
              ...n
            }
          )
        ]
      }
    ),
    t ? /* @__PURE__ */ o(f, { ...t }) : null
  ] })
);
x.displayName = "Input";
export {
  x as Input
};
